import { OverlayViewF } from '@react-google-maps/api';
import { COLORS } from '../../../utils/colors';

export const useKnowledgeBaseStyles = () => {
  return {
    backArrow: {
      textDecoration: 'underline',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
    },
    grid: {
      margin: 0,
      width: '100%',
      overflowY: 'auto',
      paddingBottom: '2rem',
    },
    gridItem: {
      paddingLeft: '1rem',
      paddingTop: 0,
      paddingBottom: '1.5rem',
    },
    back: {
      width: '100%',
      height: '2.6rem',
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0 1rem',
      alignItems: 'center',
    },
    back_arrow: {
      textTransform: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      fontSize: '.8rem',
    },
    link: {
      fontSize: '0.8rem',
      textDecoration: 'underline',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '0.5rem',
    },
    center: {
      marginTop: '3.5rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 'calc(100vh - 20rem)',
    },
    inputs: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      padding: '1rem',
      paddingTop: '2rem',
      zIndex: '1',
    },
    text: {},
    select: {
      borderRadius: '1.2rem',
      color: '#000',
      width: '50%',
    },
    sections: {
      padding: '1rem',
      paddingTop: '0px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      height: 'calc(100% - 8rem)',
      overflowY: 'scroll',
      boxSizing: 'border-box',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      height: 'calc(100% - 7rem)',
      overflow: 'scroll',
      padding: '0 1rem',
    },
    p: {
      paddingBottom: '.75rem',
      flexShrink: 0,
      fontSize: '0.75rem',
    },
    sectionTitle: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: `0rem`,
      cursor: 'pointer',
    },
    stitle: {
      margin: '.5rem 0',
      fontWeight: '600',
      color: '#0b2545',
      fontSize: '0.9rem',
      letterSpacing: '0.23px',
    },
    subtitle: {
      fontWeight: '600',
      marginBottom: '0.25rem',
      textTransform: 'uppercase',
      fontSize: '0.85rem',
    },
    img: {
      //maxWidth: '18rem',
      //width: '18rem',
      //height: 'auto',
      //margin: '.75rem auto',
      //borderRadius: '1rem',
      //border: `1px solid ${COLORS.MEDIUM_GRAY}`,

      width: '100%',
      height: '100%',
      borderRadius: '.25rem',
    },
    document_item: {
      cursor: 'pointer',
      width: '8rem',
      height: '10rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
      borderRadius: '.5rem',
      border: '1px solid #979797',
      textAlign: 'center',

      color: '#53617a',
      flexDirection: 'column',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    },
    title: {
      textTransform: 'uppercase',
      fontWeight: 600,
      fontSize: '13px',
      marginRight: '1rem',
    },
    imageOverlay: {
      display: 'flex',
      width: '100%',
      height: '100%',
      overflow: 'hidden',
    },
    down: {
      padding: '0.1rem',
      backgroundColor: 'white',
      borderRadius: '1rem',
      color: COLORS.MEDIUM_GRAY,
      marginRight: '0.5rem',
    },
    up: {
      padding: '0.1rem',
      marginRight: '0.5rem',
      marginLeft: '1rem',
      backgroundColor: 'white',
      borderRadius: '1rem',
      color: COLORS.MEDIUM_GRAY,
    },
    actionArea: {
      display: 'flex',
      borderRadius: '.625rem',
      height: '7rem',
      width: '7rem',
      marginRight: '0.5rem',
    },
    srback: {
      marginTop: '3.6rem',
      margin: '1rem',
      display: 'flex',
      justifyContent: 'space-between',
    },
    searchResult: {
      height: 'calc(100% - 11rem)',
      minHeight: '12rem',
      margin: 0,
      borderRadius: '1rem',
      padding: '1rem',
      cursor: 'pointer',
      paddingBottom: '0.5rem',
      overflowY: 'auto',
    },
    srbook: {
      width: '4rem',
      height: '5rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      backgroundColor: 'lightgray',
      padding: 1,
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: '0.8rem',
      marginRight: '1rem',
      borderRadius: '0.5rem',
      border: 'solid 1px #ebebeb',
    },
    srcover: {
      width: '100%',
      height: 'auto',
      marginBottom: '8px',
      borderRadius: '4px',
    },
    srbutton: {
      marginRight: '0.5rem',
      color: COLORS.MEDIUM_GRAY,
      cursor: 'pointer',
    },
    srrow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    },
    srbuttons: {
      display: 'flex',
      alignItems: 'center',
      borderTop: `2px solid ${COLORS.LIGHT_GRAY}`,
      borderBottom: `2px solid ${COLORS.LIGHT_GRAY}`,
      paddingTop: '0.5rem',
      paddingBottom: '0.5rem',
      justifyContent: 'space-between',
    },
  };
};
